import PropTypes from 'prop-types';

import Feed from 'core/components/Feed';
import Drum from 'core/components/Drum';
import Scroller from 'core/components/Scroller';
import Indent from 'core/components/Wrappers/Indent';

import withTheme from 'core/hocs/withTheme';
import withBreakpoint from 'core/hocs/withBreakpoint';

import themePropTypes from 'core/utils/prop-types/theme';
import { resolveScopedStyles } from 'core/utils/styled-jsx';
import { transformReadMoreLinks } from 'core/utils/content';
import modelPropTypes, { topicAttributes } from 'core/utils/prop-types/model';

import styles from './index.styl';


function Content(props) {
  const {
    content,
    theme,
    singleCard: SingleCard,
    feedCard: FeedCard,
    drumCard: DrumCard,
    isMobile,
  } = props;

  const {
    controls: {
      vikontReadMore: {
        drum: {
          arrowsShift,
          arrowsShiftVertical,
          itemWidth,
          spaceBetween,
          leftIcon,
          rightIcon,
          sideIndent,
          noCounter,
          autoHeight,
        },
        singleCard: {
          alignItems,
        },
        feed: {
          interitemSpacing,
          columns,
        },
      },
    },
  } = theme;

  if (content.length === 0) return null;

  const newContent = transformReadMoreLinks(content);

  if (newContent.length === 1) {
    return (
      <div className={styles.singleCard}>
        <style jsx>{`
          .${styles.singleCard}
            align-items ${alignItems}
        `}</style>
        <SingleCard content={newContent[0]} />
      </div>
    );
  }

  if (newContent.length < 3) {
    return (
      <Feed
        card={FeedCard}
        interitemSpacing={interitemSpacing}
        content={newContent}
        columns={columns}
      />
    );
  }

  if (isMobile) {
    const flexBasis = typeof itemWidth === 'number'
      ? itemWidth + 'px'
      : itemWidth;
    return (
      <Scroller listClassName='scroller'>
        <style jsx>{`
          .scroller
            padding-right ${spaceBetween}px
          .${styles.scrollerItem}
            margin-right ${spaceBetween}px
            flex-basis ${flexBasis}
        `}</style>
        {newContent.map(topic => (
          <div key={topic.id} className={styles.scrollerItem}>
            <DrumCard content={topic} />
          </div>
        ))}
      </Scroller>
    );
  }

  const scope = resolveScopedStyles(
    <scope>
      <style jsx>{`
        .container
          padding 0 ${sideIndent}px
      `}</style>
    </scope>
  );

  return (
    <Indent
      left={-sideIndent}
      right={-sideIndent}
    >
      <Drum
        card={DrumCard}
        arrowsShift={arrowsShift}
        arrowsShiftVertical={arrowsShiftVertical}
        showArrowsOnHover
        spaceBetween={spaceBetween}
        itemWidth={itemWidth}
        itemWidthMobile={itemWidth}
        content={newContent}
        leftIcon={leftIcon}
        rightIcon={rightIcon}
        noCounter={noCounter}
        autoHeight={autoHeight}
        containerClass={scope.wrapClassNames('container')}
      />
      <scope.styles />
    </Indent>
  );
}

Content.propTypes = {
  content: PropTypes.arrayOf(modelPropTypes(topicAttributes)),
  theme: themePropTypes(`{
    controls: {
      vikontReadMore: {
        drum: {
          arrowsShift,
          arrowsShiftVertical,
          itemWidth,
          spaceBetween,
          sideIndent,
        },
        singleCard: {
          alignItems,
        },
        feed: {
          interitemSpacing,
        },
      }
    },
  }`),
  singleCard: PropTypes.func,
  feedCard: PropTypes.func,
  drumCard: PropTypes.func,
  isMobile: PropTypes.bool,
};

export default withTheme(withBreakpoint(Content));
